import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SignatureService } from '../../providers/signature.service';
import { View_signature } from '../../models/view_signature';
import { Person } from '../../models/person';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';
import { faCheck } from '@fortawesome/fontawesome-pro-regular';
import { faPenNib } from '@fortawesome/pro-regular-svg-icons';

@Component({
  standalone: false,
  selector: 'app-submit-signature',
  templateUrl: './submit-signature.component.html',
styleUrls:  ['./submit-signature.component.css']
})
export class SubmitSignatureComponent extends SmsAbstractAppPage implements OnInit {

	faCheck = faCheck;
	faPenNib = faPenNib;
	submitted: boolean = false;
	response: string = '';
  already_signed: boolean = false;

	signature: View_signature = new View_signature({});

  constructor(private route: ActivatedRoute, private signatureService: SignatureService) {
  	super();
  }

  ngOnInit() {

  	this.route.params.subscribe(params => {
          if(params['id']){
          	this.signatureService.getViewSignatureById(params['id']).then(signature => {
          		this.signature = signature;
              if(signature.id != undefined && (signature.read_document && signature.accepted_terms && signature.signature != '')){
                this.already_signed = true;
              }
          	}).catch(error => {
          		this.handleError(error);
          	});
          }
  	});

   }

   handleSubmitSignature() {
   	if(this.signature.signature == '' || this.signature.accepted_terms == false || this.signature.read_document == false){
      this.handleError("The entry must be signed and the signer must indicate that they have read and accepted the terms of entering this horse show.");
      return;
    }
    this.submitted = true;
    this.signatureService.updateGuestSignature(this.signature).then(response => {
    	this.response = response;
    }).catch(error => {
    	this.handleError(error);
    	this.submitted = false;
    });

   }

}
